<template>
    <div style="width: 100%; position: relative" class="pa-2">
        <TitleComponent :box="box" :text="box.reportProperties.title" />
        <!-- <div v-if="box && box.properties.title" class="title text-field center d-flex align-center" :style="titleBoxStyle"><span style="width: 100%;">{{ box.properties.title }}</span></div> -->
        <div style="width: 100%; overflow-x: auto" class="scrollbar-hidden">
            <template v-if="uiType === 'card'">
                <component :is="cardTag" v-bind="cardProps" :key="refreshKey" />
            </template>
            <template v-else-if="uiType === 'chart'">
                <v-card flat style="height: 100%">
                    <!-- <v-card-title class="px-0" v-if="!preview">
                        <div style="width: 50%;">
                            <v-select
                                :items="box.names"
                                v-model="selectedNames"
                                multiple
                                label="Postes"
                                dense
                                outlined
                                class="oss-dark"
                                :full-width="false"
                                hide-details="auto"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <span v-if="selectedNames && selectedNames.length === 1">{{ item.text }}</span>
                                    <span
                                        v-else
                                        v-show="index === 0"
                                        class="grey--text text-caption"
                                    >
                                        {{ selectedNames.length }} sélections
                                    </span>
                                </template>
                            </v-select>
                        </div>
                    </v-card-title> -->
                    <div style="width: 100%">
                        <ChartComponent
                            v-if="chartData.datasets"
                            :chartData="chartData"
                            :chartOptions="box.chartOptions"
                            :chartType="themeChartType"
                        />
                    </div>
                </v-card>
            </template>
            <template v-else-if="uiType === 'table'">
                <TableComponent
                    :key="tableComponentRefreshKey"
                    :tableTheme="tableTheme"
                    :tableData="tableData"
                />
                <!-- <table style="width: 100%; table-layout: auto; border-spacing: 0;">
                    <thead>
                        <tr :style="thStyle">
                            <th v-for="(header, index) of box.tableData.header" :key="index" class="text-startt" :style="thStyle">{{ header }}</th>
                        </tr>
                    </thead>
                    <tbody style="text-align: right;" :style="box.selectedTableTheme.values.rows">
                        <tr v-for="(row, rIndex) of box.tableData.rows" :key="rIndex" class="text-startt">
                            <td v-for="(item, index) of row" :key="index" class="text-startt" :style="tdStyle(rIndex)">{{ item }}</td>
                        </tr>
                    </tbody>
                </table> -->
            </template>
        </div>
    </div>
</template>
<script lang="ts">
import { Box, AccountingResultsBoxModel, Layout } from "../models";
import AccountingTable from "@/views/dashboardAccounting/AccountingTable.vue";
import { chartColors } from "../../../../../backend/src/common/chart/graphServices";
import ChartComponent from "../ChartComponent.vue";
import TableComponent from "../TableComponent.vue";
import { newCommonFormatCurrency } from "../../../../../backend/src/common/services/mathServices";
import moment from "moment-timezone";
import BoxPopupMenu from "../BoxPopupMenu.vue";

import DesignerDataService from "../designerDataService";
import TitleComponent from "../TitleComponent.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    components: {
        AccountingTable,
        ChartComponent,
        TableComponent,
        BoxPopupMenu,
        TitleComponent,
    },
})
export class AccountingResults extends Vue {
    @Prop() box: AccountingResultsBoxModel;
    @Prop() preview: boolean;

    dataService: DesignerDataService = null;

    tableComponentRefreshKey = 0;

    get selectedNames(): string[] {
        return this.box.mergedProperties.selectedNames;
    }

    get maxNamesSelection() {
        return this.box.properties.nGraphParts || 2;
    }

    get company() {
        return this.$store.state.selected_company;
    }

    get accountingPeriodId() {
        console.log("this.$store.state", this.$store.state);
        console.log(
            "this.$store.state.accountingPeriod?.selectedAccountingPeriod?.id",
            this.$store.state.accountingPeriod?.selectedAccountingPeriod?.id,
        );
        return this.$store.state.accountingPeriod?.selectedAccountingPeriod?.id;
    }

    get selectedAccountingPeriod() {
        return this.$store.state.accountingPeriod?.selectedAccountingPeriod;
    }

    get selectedAccountingClosing() {
        return this.$store.state.accountingPeriod?.selectedAccountingClosing;
    }

    get accountingPeriods() {
        return this.$store.state.accountingPeriod?.accountingPeriods;
    }

    beforeMount() {
        console.log("tableData", this.tableData);
        this.dataService = new DesignerDataService(this.company);
        if (!this.box.data?.rows?.length) {
            this.fetchData();
        }
    }

    @Watch("box.reportProperties.periodStart")
    @Watch("box.reportProperties.periodEnd")
    @Watch("selectedAccountingPeriod")
    @Watch("box.properties.dense")
    @Watch("box.properties.nm1")
    @Watch("box.reportProperties.tableType")
    @Watch("box.reportProperties.flashAccount")
    @Watch("box.reportProperties.sigAccount")
    @Watch("box.reportProperties.bilanAccount")
    @Watch("box.reportProperties.resultsAccount")
    async fetchData() {
        console.log("this.dataService", this.dataService);
        console.log("this.box.selectedOperatingAccount", this.box.selectedOperatingAccount);
        if (this.periods?.length) {
            const [data, dashboardTable] = await this.dataService.fetchAccountingResultsTableData(
                {
                    className: "OperatingAccountCustom",
                    budgetId: "", // TODO need to fetch budgetId and provide a  way to select one
                    periods: this.periods,
                    // periods: [
                    //     {
                    //         "start": "2024-01-01",
                    //         "end": "2024-12-31",
                    //         "monthly": true, //this.selectedBox?.properties?.dense === false,
                    //         "accountingPeriodId": "clpweci910002h5m494c0tccq"
                    //     },
                    //     {
                    //         "start": "2023-01-01",
                    //         "end": "2023-12-31",
                    //         "accountingPeriodId": "clbyowol44080g9smsajj89uh",
                    //         "type": "nMoinsUn"
                    //     }
                    // ],
                    // tags: [],
                    tags: this.box.mergedProperties.tableType !== "Bilan" ? [] : undefined,
                    operatingAccountId: this.box.selectedOperatingAccount?.id, //"clesc5ora0022gism9uwft9lr",
                    accountingPeriodId: this.accountingPeriodId,
                },
                true,
            );

            console.log("dashboardTable", dashboardTable);

            this.box.data = data;
        }

        if (this.box.selectedOperatingAccount) {
            this.box.reportProperties.title = this.box.selectedOperatingAccount.name;
        }

        console.log("this.box.data", this.box.data);
    }

    @Watch("selectedAccountingPeriod")
    onAccountingPeriodChange(newVal) {
        if (this.box) {
            this.box.accountingPeriod = this.selectedAccountingPeriod;
            // Reset the values of selected periods
            this.box.mergedProperties.periodStart = "";
            this.box.mergedProperties.periodEnd = "";
        }
    }

    // @Watch("selectedNames")
    // onNamesSelected(val) {
    //     while (this.selectedNames?.length > this.maxNamesSelection) {
    //         this.selectedNames.pop()
    //     }
    //     // this.selectedTableData
    //     console.log("this.chartDataForLine", this.chartDataForLine)
    //     console.log("this.chartDataForBar", this.chartDataForBar)
    // }

    @Watch("box.reportProperties.selectedNames", { deep: true })
    onNamesSelected(val) {
        debugger;
        while (this.box.reportProperties?.selectedNames?.length > this.maxNamesSelection) {
            this.box.reportProperties.selectedNames.pop();
        }
        // this.selectedTableData
        console.log("this.chartDataForLine", this.chartDataForLine);
        console.log("this.chartDataForBar", this.chartDataForBar);
    }

    options = {
        SIG: {
            title: "Solde intermédiaire de gestion",
            className: "OperatingAccountCustom",
            type: "SIG",
            accountingPeriodRequired: false,
        },
        results: {
            title: "Compte de résultat",
            className: "OperatingAccountCustom",
            type: "INCOME_STATEMENT",
            accountingPeriodRequired: false,
        },
        Bilan: {
            title: "Bilan",
            className: "OperatingAccountCustom",
            type: "BALANCE_SHEET",
            accountingPeriodRequired: true,
        },
        OperatingAccountFromPartition: {},
        // "4": { title: this.selectorCustomOA, className:'OperatingAccountCustom', type: 'MISCELLANEOUS', accountingPeriodRequired: false },
        // "5": { title: "Tableau de financement", className:'CashFlowStatement',   accountingPeriodRequired: true},
        Flash: {
            title: "Flash",
            className: "OperatingAccountCustom",
            type: "FLASH_SITUATION",
            accountingPeriodRequired: false,
        },
    };

    get uiType() {
        return this.box?.mergedProperties?.ui;
    }

    get cardTag() {
        return this.box?.bobbeeCardTag;
    }

    get cardProps() {
        const props = {
            operatingAccountId: this.box.selectedOperatingAccount?.id,
            myKey: this.box.mergedProperties.tableType,
            currentKey: this.box.mergedProperties.tableType,
            options: this.options[this.box.mergedProperties.tableType],
            periods: this.periods,
            tags: this.box.mergedProperties.tableType === "Bilan" ? undefined : [],
            displayMonthlyData:
                this.box.mergedProperties.tableType === "Bilan"
                    ? false
                    : !this.box.mergedProperties.dense,
            round: true,
            embedded: true,
            // withSelector: this.operatingAccountsData.length > 1,
        };

        // const bCardProps = JSON.parse(JSON.stringify((this.box?.bobbeeCardProps) as any))
        // if (bCardProps) {
        //     bCardProps.displayMonthlyData = this.box.properties.dense === false

        //     bCardProps.periods = this.periods

        //     // if (bCardProps.periods?.length) {
        //     //     bCardProps.periods[0].monthly = bCardProps.displayMonthlyData
        //     //     let i = 0
        //     //     for (const period of bCardProps.periods) {
        //     //         if (period.type === "nMoinsUn" && !this.box.properties.nm1) {
        //     //             bCardProps.periods.splice(i, 1)
        //     //         }
        //     //         i++
        //     //     }
        //     // }
        // }
        // console.log("bCardProps", bCardProps)
        // return bCardProps ?? {}
        return props;
    }

    get refreshKey() {
        return JSON.stringify(this.cardProps);
    }

    get selectedTableData() {
        const data = this.box.selectTableDataByKeys(this.selectedNames);
        console.log("selectedTableData", data);
        return data;
    }

    get themeChartType() {
        return this.box.selectedChartTheme.values.type ?? "bar";
    }

    get chartData() {
        // debugger
        if (["line"].includes(this.themeChartType)) {
            return this.chartDataForLine;
        }
        return this.chartDataForBar;
    }

    get chartDataForLine() {
        const data: any = {};
        if (this.box.mergedProperties.dense) {
            // TODO: Check the dense option
            data.labels = ["N", "N-1"]; // this.box.properties.nm1 ? ["N-1", "N"] : ["N"]
            // const totals = this.selectedData.rows.map(row => row.reduce((total, x) => total + x, 0))
            const datasets = [];

            this.selectedTableData.forEach((row) => {
                if (row.netAmounts?.length) {
                    datasets.push({
                        data: row.netAmounts.map((x) => x * (row.displaySign ?? 1)),
                        label: row.name,
                    });
                }
            });

            data.datasets = datasets;
        } else {
            data.datasets = [];
            data.labels = [];
        }
        this.formatDataForChartJS(data);
        // const chartType = this.box.selectedChartTheme ? this.box.selectedChartTheme.values.type : "bar"
        // const colorPalette = this.box.selectedChartTheme ? this.box.selectedChartTheme.values.palette : "cool"
        // switch(chartType) {
        //     case "pie":
        //     case "doughnut":
        //         data.datasets.forEach(dataset => {
        //             chartColors(chartType, dataset, colorPalette)
        //         });
        //         break
        //     case "bar":
        //     case "line":
        //     default:
        //         chartColors(chartType, data.datasets, colorPalette)
        //         break

        // }
        console.log("AccountingResults chartData", data);
        return data;
    }

    get chartDataForBar() {
        const data: any = {};
        if (this.box.mergedProperties.dense) {
            const usableTableData = this.selectedTableData.filter(
                (row) => row.name && row.netAmounts?.length,
            );
            data.labels = usableTableData.map((row) => row.name);
            // const totals = this.selectedData.rows.map(row => row.reduce((total, x) => total + x, 0))
            const datasets = []; //data.labels.map(_ => ({data: []}))

            const subLabels = this.box.mergedProperties.nm1 ? ["N", "N-1"] : ["N"];

            // const ln = this.selectedTableData[0]?.netAmounts?.length

            subLabels.forEach((lab, index) => {
                const dataset = { data: [], label: lab };
                for (let i = 0; i < data.labels.length; i++) {
                    dataset.data.push(
                        usableTableData[i].netAmounts[index] *
                            (usableTableData[i].displaySign ?? 1),
                    );
                }
                datasets.push(dataset);
            });

            // for (let  i = 0; i < ln; i++) {
            //     this.selectedTableData.forEach((row, index) => {
            //         if (row.netAmounts?.length) {
            //             datasets[index].data.push(row.netAmounts[i] * (row.displaySign ?? 1))
            //             datasets[index].label = subLabels[i]
            //             // datasets.push({
            //             //     data: row.netAmounts.map(x => x * (row.displaySign ?? 1)),
            //             //     label: row.name
            //             // })
            //         }
            //     });
            // }

            // for (let  i = 0; i < ln; i++) {
            //     // datasets[i].data.push()
            //     this.selectedTableData.forEach((row, index) => {
            //         if (row.netAmounts?.length) {
            //             datasets[index].data.push(row.netAmounts[i] * (row.displaySign ?? 1))
            //             datasets[index].label = subLabels[i]
            //             // datasets.push({
            //             //     data: row.netAmounts.map(x => x * (row.displaySign ?? 1)),
            //             //     label: row.name
            //             // })
            //         }
            //     });
            // }

            data.datasets = datasets;
        } else {
            data.datasets = [];
            data.labels = [];
        }
        this.formatDataForChartJS(data);
        // const chartType = this.box.selectedChartTheme ? this.box.selectedChartTheme.values.type : "bar"
        // const colorPalette = this.box.selectedChartTheme ? this.box.selectedChartTheme.values.palette : "cool"
        // switch(chartType) {
        //     case "pie":
        //     case "doughnut":
        //         data.datasets.forEach(dataset => {
        //             chartColors(chartType, dataset, colorPalette)
        //         });
        //         break
        //     case "bar":
        //     case "line":
        //     default:
        //         chartColors(chartType, data.datasets, colorPalette)
        //         break

        // }
        // console.log("AccountingResults chartData2", data)
        return data;
    }

    formatDataForChartJS(data) {
        const chartType = this.box.selectedChartTheme
            ? this.box.selectedChartTheme.values.type
            : "bar";
        const colorPalette = this.box.selectedChartTheme
            ? this.box.selectedChartTheme.values.palette
            : "cool";
        switch (chartType) {
            case "pie":
            case "doughnut":
                data.datasets.forEach((dataset) => {
                    chartColors(chartType, dataset, colorPalette);
                });
                break;
            case "bar":
            case "line":
            default:
                chartColors(chartType, data.datasets, colorPalette);
                break;
        }
        console.log("AccountingResults chartData2", data);
        return data;
    }

    formatTableRowData(row, valueKey) {
        let nAmountColumns;
        let baseAmounts = [];
        if (valueKey === "netAmounts") {
            nAmountColumns = 2;
            baseAmounts = row.netAmounts;
        } else if (valueKey === "monthlyAmounts") {
            nAmountColumns = 14;
            baseAmounts = row.monthlyAmounts?.netAmounts;
            if (baseAmounts && this.box.mergedProperties.nm1) {
                baseAmounts.push(...row.netAmounts);
            } else if (baseAmounts) {
                baseAmounts.push(row.netAmounts[0]);
            }
        }

        // let dummyAmounts = Array.from({length: nAmountColumns - (Number(!this.box.mergedProperties.nm1))},(_v) => "")
        // console.log("row?.[valueKey]", row?.[valueKey])

        const amounts = baseAmounts
            ? baseAmounts.concat().map((a) => a * (row.displaySign || 1))
            : []; //dummyAmounts
        const diff = row.difference; //netAmounts?.length === 2 ? netAmounts[0] - netAmounts[1] : 0
        const percent = row.percentage ?? 0;
        const formattedAmounts = amounts.map((a) => a);
        const values = [
            { text: row.title ? row.title : row.name, type: "string" },
            ...formattedAmounts.map((amount) => ({ text: amount, type: "amount" })),
        ];
        if (this.box.mergedProperties.nm1 && row?.[valueKey]) {
            values.push({ text: diff, type: "amount" });
            values.push({ text: percent, type: "percent" });
        }

        const formattedRow = {
            type: row.title ? "title" : "normal",
            values: values,
        };

        return formattedRow;
    }

    @Watch("tableData")
    updateTableComponentRefreshKey() {
        this.tableComponentRefreshKey += 1;
    }

    get tableData() {
        if (this.box.mergedProperties.tableType === "Bilan") {
            // Table for for bilan is built differently fron the other tables
            console.log("tableDataForBilan", this.tableDataForBilan);
            return this.tableDataForBilan;
        }
        // debugger
        const baseData = JSON.parse(JSON.stringify(this.box.data));
        if (this.box.mergedProperties.dense) {
            baseData.headers = baseData.headers.map((header) => [
                { text: "Postes" },
                { text: "N" },
                { text: "N-1" },
                ...header.slice(3),
            ]);
        }
        if (!this.box.mergedProperties.nm1) {
            baseData.rows = baseData.rows.map((row) => {
                if (row.title && !row.netAmounts?.length) {
                    return row;
                } else if (row.netAmounts?.length) {
                    // debugger
                    row.netAmounts = [row.netAmounts[0]]; // N is at position 0 in the data structure
                }
                return row;
            });

            baseData.headers = baseData.headers.map((header) => header.slice(0, 2)); // baseData.headers.map(header => [{text: "Postes"}, {text: "N"}])
        }

        console.log("baseData.headers", baseData.headers);

        let headers = baseData.headers[1]?.map((h) => h.text) ?? [];
        let valueKey = "netAmounts";
        if (!this.box.mergedProperties.dense) {
            const extraHeaders = this.box.mergedProperties.nm1
                ? ["N-1", "Différence", "Pourcentage"]
                : [];
            valueKey = "monthlyAmounts";
            headers = [
                "Postes",
                ...this.monthsToDisplay.map((x) => this.monthsInLetter(x)),
                "Total N",
                ...extraHeaders,
            ];
        }

        const rows = [];

        baseData.rows.forEach((row, index) => {
            rows.push(this.formatTableRowData(row, valueKey));
        });

        // console.log("tableData fffffffffff", {headers, rows})

        return { headers, rows };
    }

    formatTableRowDataForBilan(row: any, columns: any[]) {
        const fRow = {
            type: row.title ? "title" : "normal",
            values: [{ text: row.title ?? row.name, type: "string" }],
        };

        // debugger
        for (const col of columns) {
            const obj = row?.[col.key];
            if (obj == null) continue;
            if (col.key === "netAmounts") {
                // N and N-1 are returned together in the same array as [N, N-1]
                fRow.values.push({ text: obj?.[0], type: "amount" }); // N
                if (this.box.mergedProperties.nm1) {
                    fRow.values.push({ text: obj?.[1], type: "amount" }); // N-1
                }
            } else {
                fRow.values.push({ text: obj?.[0], type: "amount" });
            }
        }

        return fRow;
    }

    get tableDataForBilan() {
        const baseData = JSON.parse(JSON.stringify(this.box.data));
        const headers = baseData.headers?.[1].map((h) => h.text);
        // The default names of headers use the name Net for both N and N-1.
        if (this.box.mergedProperties.nm1) {
            headers[headers.length - 2] = "N";
            headers[headers.length - 1] = "N-1";
        } else {
            headers[headers.length - 1] = "N";
        }
        const rows = [];
        const columns = baseData.columnsToDisplay[0];
        console.log("columns", columns);
        baseData.rows.forEach((row, index) => {
            const fRow = this.formatTableRowDataForBilan(row, columns);
            rows.push(fRow);
        });

        return { headers, rows };
    }

    get tableTheme() {
        return this.box.selectedTableTheme?.values;
    }

    get monthsToDisplay() {
        const result = [];
        const periods = this.periods; //this.box.bobbeeCardProps.periods
        for (const period of periods) {
            if (period.monthly && period === periods[0]) {
                const monthDifference = moment(period.end).diff(moment(period.start), "month");
                for (
                    let number = moment(period.start).month();
                    number <= moment(period.start).month() + monthDifference;
                    number++
                ) {
                    result.push(number % 12);
                }
            }
        }
        return result;
    }

    monthsInLetter(month: number) {
        // if changements, change also monthsInLetter function in exportBooklet.ts
        const dicoMonthsInLetter = {
            0: "Jan",
            1: "Fev",
            2: "Mar",
            3: "Avr",
            4: "Mai",
            5: "Jun",
            6: "Jul",
            7: "Aou",
            8: "Sep",
            9: "Oct",
            10: "Nov",
            11: "Dec",
        };
        return dicoMonthsInLetter[month];
    }

    getPreviousAccountingPeriod() {
        const index = this.accountingPeriods.findIndex(
            (e) => e.id === this.selectedAccountingPeriod.id,
        );
        if (index > 0) {
            return this.accountingPeriods[index - 1]?.id;
        }
        return null;
    }

    get periods() {
        const periods = [];
        const firstPeriodStart = this.box.mergedProperties.periodStart;
        const firstPeriodEnd = this.box.mergedProperties.periodEnd;
        const displayNMoinsUn = this.box.mergedProperties.nm1;
        const displayMonthlyData = !this.box.mergedProperties.dense;

        if (firstPeriodStart && firstPeriodEnd) {
            periods.push({
                // start: this.step === 'Bilan' ? undefined: moment(this.firstPeriodStart).format("YYYY-MM-DD"),
                start: moment(firstPeriodStart).format("YYYY-MM-DD"),
                end: moment(firstPeriodEnd).format("YYYY-MM-DD"),
                monthly: displayMonthlyData,
                accountingPeriodId: this.selectedAccountingPeriod.id,
                accountingClosingId: this.selectedAccountingClosing?.id || undefined,
            });
        }
        const previousAccountingPeriodId = this.getPreviousAccountingPeriod();
        if (displayNMoinsUn && previousAccountingPeriodId) {
            let start = moment(firstPeriodStart).subtract(1, "years").format("YYYY-MM-DD");
            let end = moment(firstPeriodEnd).subtract(1, "years").format("YYYY-MM-DD");
            // if (this.comparisonType === 1) {
            //     start = moment(this.selectedAccountingPeriod.start).subtract(1, 'years').format("YYYY-MM-DD")
            //     end = moment(this.selectedAccountingPeriod.end).subtract(1, 'years').format("YYYY-MM-DD")
            // }
            periods.push({
                // start: this.step === 'Bilan' ? undefined : start,
                start,
                end,
                accountingPeriodId: previousAccountingPeriodId,
                type: "nMoinsUn",
            });
        }
        // if(this.selectedBudget ) {
        //     if (this.budgets[this.selectedBudget].id) {
        //         let start = moment(this.firstPeriodStart).format("YYYY-MM-DD")
        //         let end = moment(this.firstPeriodEnd).format("YYYY-MM-DD")
        //         if (this.comparisonType === 1) {
        //             start = this.selectedAccountingPeriod.start
        //             end = this.selectedAccountingPeriod.end
        //         }
        //         periods.push({
        //             start,
        //             end,
        //             type: "budget",
        //             budgetId: this.budgets[this.selectedBudget].id,
        //         },)
        //     } else if (this.budgets[this.selectedBudget].type === "freeBudget") {
        //         periods.push({
        //             // start,
        //             // end,
        //             type: "freeBudget",
        //             // budgetId: this.budgets[this.selectedBudget].id,
        //         })
        //     }
        // }
        return periods;
    }
}

export default toNative(AccountingResults);
</script>
<style lang="css" scoped>
.text-field {
    height: 100%;
    width: 100%;
}

:is(.text-field, td, th, tr):is(.center, .middle, .text-center, .text-middle) {
    text-align: center;
}

:is(.text-field, td, th, tr):is(.start, .text-start) {
    text-align: start;
}

:is(.text-field, td, th, tr):is(.end, .text-end) {
    text-align: end;
}

.title {
    border: 1px solid;
    overflow-x: hidden;
    text-wrap: wrap;
}

.scrollbar-hidden::-webkit-scrollbar {
    overflow: auto;
    display: none;
    width: 12px;
}

.scrollbar-hidden {
    overflow: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
}
</style>
